/**
 * Player instants are rounded to whole seconds by getAbsoluteDateFromPlayerTime,
 * and `playerVideoCurrentTime` trails the real playhead by up to a progress tick
 * (100ms). Marking a statement and then closing the cut with F9 right after can
 * therefore land the end one rounded second *before* the statement, which is
 * quantisation noise, not a mistake. The mismatch this guards against — a
 * statement timestamped in another segment — is minutes wide, so a couple of
 * seconds of slack costs nothing.
 */
const CUT_WINDOW_TOLERANCE_MS = 2000;

/**
 * A null `cutEnd` means the cut is still open (F2 taken, F9 not yet, or the end
 * mark dropped with F8), so only the lower bound constrains the instant.
 */
function isWithinCutWindow(datetime: Date, cutStart: Date, cutEnd: Date | null): boolean {
  const time = datetime.getTime();

  if (time < cutStart.getTime() - CUT_WINDOW_TOLERANCE_MS) return false;
  if (!cutEnd) return true;

  return time <= cutEnd.getTime() + CUT_WINDOW_TOLERANCE_MS;
}

export { isWithinCutWindow };
